export const chartData = [
  { name: "Group A", value: 400 },
  { name: "Group B", value: 30 },
  { name: "Group C", value: 80 },
  { name: "Group D", value: 20 },
  { name: "Group E", value: 100 },
  { name: "Group F", value: 110 },
];

export const colors = [
  "#0088FE",
  "#00C49F",
  "#FFBB28",
  "#FF8042",
  "#FF00FF",
  "#D2E6B1",
];
